import { accountsEnvironment } from '../accounts-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { PagedCollectionParams } from '../../../models/paged-collection-params';
import { createPagedCollectionSchema } from '../../../utils/create-paged-collection-schema';
import { accountLicenseAllocationSchema } from '../schemas/account-license-allocation.schema';
import { fromFetch } from 'rxjs/fetch';

/**
 * Used by a Trimble Maps partner to get a report of all licenses and their usage accross all of their accounts.
 * @param params Paged Collection Params
 * @returns Paged Collection of Account License Allocations
 */
export function getResellerReportsLicenses(
  this: unknown,
  params?: PagedCollectionParams
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${accountsEnvironment.resolve(this).resellerReportsLicensesUrl}${
          params ? `?${params.urlParams}` : ''
        }`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(
    selectData(createPagedCollectionSchema(accountLicenseAllocationSchema))
  );
}
